export default {
  title: "Diensten",
  laundry: {
    title: "Wasservice",
    free: "Gratis",
    washing_machine: "Wasmachine",
    dryer: "Droogkast",
    per_cycle: "/ cyclus",
    pay_and_start: "Betalen & Starten",
    in_use: "In gebruik",
    location: "Wasruimte op verdieping 1, kamer 105"
  },
  reductions: {
    title: "Actieve kortingen",
    subtitle: "Bespaar extra op je boeking met deze aanbiedingen",
    valid_until: "Geldig tot",
    auto_apply: "Automatisch toegepast",
    note: "Dit zijn momenteel actieve kortingen. Extra boekingsvoorwaarden kunnen nog van toepassing zijn.",
    expiring_soon: "Bijna verlopen",
    valid_for_buildings: "Geldig voor:",
    valid_for_all_buildings: "Geldig voor alle gebouwen",
    max_occupancy: "Max gasten:",
    selected_unit_types: "Enkel geldig voor geselecteerde kamertypes",
    stay: "Verblijf:",
    stay_from: "Verblijf vanaf",
    days: "dagen",
    travel_dates: "Reisdata:",
    travel_from: "Reizen vanaf:",
    travel_until: "Reizen tot:",
    use_once_per_guest: "Kan één keer per gast gebruikt worden",
    use_up_to: "Kan tot",
    times_per_guest: "keer per gast gebruikt worden",
    manual_code: "Promocode moet mogelijk manueel ingevoerd worden",
    description_percentage: "Procentuele korting",
    description_fixed_amount: "Vaste korting",
    description_free_night: "Gratis nacht",
    description_free_nights: "Gratis nachten",
    description_free_option: "Gratis optie",
    description_default: "Korting",
    available_count: "promoties beschikbaar",
    code_copied: "Promocode gekopieerd",
    code_copy_failed: "Promocode kon niet gekopieerd worden",
    tap_to_copy: "Tik op een promotiekaart om de code te kopiëren",
    book_now: "Boek nu",
    view_buildings: "Bekijk gebouwen"
  },
  extras: {
    title: "Maak je verblijf nog beter",
    add: "Toevoegen"
  },
  cleaning: {
    title: "Poetsdiensten",
    intro: "Reserveer poetsmateriaal en haal het voor je poetsbeurt op aan de receptie.",
    pickup: "Ophalen aan de receptie",
    reserve: "Reserveren",
    free: "Gratis",
    kit_note: "Liever je eigen materiaal? Aan de receptie kan je ook een schoonmaakkit aankopen."
  },
  faq: {
    title: "Veelgestelde vragen",
    search_label: "Zoek in vragen...",
    no_results: "Geen veelgestelde vragen gevonden.",
    select_building: "Selecteer je gebouw",
    select_building_first: "Selecteer een gebouw om de veelgestelde vragen te bekijken."
  },
  support: {
    title: "Ondersteuning",
    sales: {
      title: "Bel sales",
      subtitle: "Nu bereikbaar op "
    },
    call: {
      title: "Bel residentiemanager"
    },
    chat: {
      title: "Live chat",
      subtitle: "Snelle reactie"
    },
    directions: {
      title: "Routebeschrijving",
      subtitle: "Navigeer naar hotel",
      url: "https://maps.google.com"
    },
    emergency: {
      title: "Noodcontact",
      subtitle: "Enkel bellen in geval van nood."
    }
  }
};
